/*
 * @Author: your name
 * @Date: 2020-09-16 17:05:01
 * @LastEditTime: 2020-09-16 17:23:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\lzxy-homepage\src\pages\home\homeConst.ts
 */
export const homeModuleTitle = {
  NEWSINFO: '新闻资讯',
  FEATURESENTERPRISE: '企业风采',
  CONTACTUS: '联系我们'
}
